import { createPortal } from "react-dom";
import PageHeader from "./PageHeader";
import { useEffect, useState } from "react";

export default function PageHeaderPortal(props) {
  const [target, setTarget] = useState(null);

  useEffect(() => {
    const el = document.getElementById("global-page-header");
    setTarget(el);

    return () => {
      if (el) el.innerHTML = ""; // wyczyść header przy zmianie strony
    };
  }, []);

  if (!target) return null;

  return createPortal(<PageHeader {...props} />, target);
}
